import * as React from 'react';

import { useTranslations } from '~src/commons/utils/translations/translate';
import { fontStyles } from '~src/theme/fontStyles';
import { Checkbox } from '~src/ui/checkbox';

interface BillingAddressCheckboxProps {
  id: string;
  checked: boolean;
  onChange: () => void;
  disabled?: boolean;
}

export const BillingAddressCheckbox: React.FC<BillingAddressCheckboxProps> = ({ id, ...props }) => {
  const { tICU } = useTranslations();

  return (
    <div css={styles.checkbox}>
      <Checkbox labelId={id} {...props} />
      <label css={styles.label} htmlFor={id}>
        {tICU('widget.delivery_address.BILLING_ADDRESS_CHECKBOX')}
      </label>
    </div>
  );
};

const styles = {
  checkbox: {
    display: 'flex',
    ...fontStyles.px14_20,
    padding: '4px 0',
    margin: '16px 0',
  },
  label: {
    marginLeft: '4px',
  },
};
